import React from 'react';
import { translate } from 'react-i18next';
import _ from 'underscore';
import { Segment, Card, Label, Icon, Button, Message } from 'semantic-ui-react';

import ProgressBar from 'modules/misc/ProgressBar.js';
import Utils from 'utils/Utils.js';
import LoadInline from 'modules/loading/LoadInline.js';
import {colors} from 'style';

var style = {
    content: {
        padding: '1px',
        position:'relative'
    },
    segment: {
        border: 'none',
        boxShadow: 'none',
    },
    cards: {
        justifyContent: 'center',
    },
    card: {
        overflow:'hidden'
    },
    pseudoCard: {
        height: '0px',
        minHeight: '0px',
        border: 'none',
        boxShadow: 'none',
        visibility: 'hidden',
        marginTop: '0',
        marginBottom: '0',
    },
    activityImage: {
        maxHeight:'8em'
    },
    iconHeader: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        height:'62px', 
        padding:'5px 60px 0px 60px', 
        width:'100%',
        color: '#fff',
        backgroundColor: colors.themeTeal,
    },
    categoryBadge: {
        position: 'absolute',
        top: '10px',
        left: '10px',
        width: '40px',
        height: '40px',
        border: '2px solid #fff',
        backgroundPosition:'50% 50%', 
        backgroundSize:'cover',
        borderRadius: '4px',
        backgroundColor: '#fff',
        color: colors.themeDarkGrey,
        fontSize: '30px',
        textAlign: 'center',
        lineHeight: '38px',
    },
    checkmark: {
        position: 'absolute',
        top: '15px',
        right: '10px',
        backgroundColor: '#fff',
        color: colors.themeTeal,
        border: '0px solid #fff',
        boxShadow:'none',
    },
    levelText: {
        fontWeight: 'light',
        fontSize: '0.9em',
    },
    progressBar: {
        backgroundColor: '#fff',
    }
};

const UserChallenges = ({t, userChallenges, onLaunchUserChallenge, formatDuration, typeToName, busy}) => (
    <div style={style.content}>
    <Segment style={style.segment}>
        {busy && 
            <LoadInline centered /> 
        }
        {!busy && 
            <Card.Group style={style.cards}>
                {userChallenges.map((item)=>(
                        <Card key={item.id} style={style.card} onClick={Boolean(item.challenge.category.userCategory && item.challenge.category.userCategory.categoryLevel) ? ()=>onLaunchUserChallenge(item) : null}>
                            <div style={style.iconHeader}>
                                {Boolean(item.challenge.category.badge) ? (
                                    <div style={{...style.categoryBadge, backgroundImage:Utils.url(item.challenge.category.badge.url)}} />
                                    ) : (
                                    <i style={{...style.categoryBadge, ...style.defaultCategoryBadge}} className='icon-myHealthSphere-logo' />
                                    )
                                }
                                {!Boolean(item.challenge.category.userCategory && item.challenge.category.userCategory.categoryLevel) && 
                                    <div style={{height:'15px'}} />
                                }
                                {item.challenge.category.title}
                                {Boolean(item.challenge.category.userCategory && item.challenge.category.userCategory.categoryLevel) && 
                                    <div>
                                        <ProgressBar style={style.progressBar} value={item.challenge.category.userCategory.levelActivitiesCompleted} total={item.challenge.category.userCategory.categoryLevel.numRequired} borderWidth={'0'} />
                                        <Card.Description style={style.levelText}>
                                            {t('progress_{{completed}}_{{required}}_{{level}}',
                                                {completed: item.challenge.category.userCategory.levelActivitiesCompleted,
                                                 required:  item.challenge.category.userCategory.categoryLevel.numRequired,
                                                 level:     item.challenge.category.userCategory.level})}
                                        </Card.Description>
                                    </div>
                                }
                                <Icon style={style.checkmark} circular name='checkmark'></Icon> 
                            </div>
                        </Card>
                    ))
                }
                {/*hack to force left alignment of last row*/}
                {_.times(10, i=>(<Card key={i} style={{...style.card, ...style.pseudoCard}} />))}
            </Card.Group>
        }
    
    </Segment>
    </div>
);
export default translate('challenges')(UserChallenges);



// WEBPACK FOOTER //
// ./src/modules/challenges/UserChallenges.js